import Countback from "../../components/countback";
import {Link, useParams} from "react-router-dom";
import {useEffect, useState} from "react";
import associateServices from "../../services";
import Loading from "../../components/loading";
import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";
import stringHelper from "../../helpers/string-helper";

const RaceDetail = () => {

    let {uuid} = useParams()
    const {activeLanguage} = useSelector(state => state.globalReducer)

    const {i18n, t} = useTranslation();
    const currentLanguage = i18n.language; // Get the current language

    const [data, setData] = useState({})
    const [loading, setLoading] = useState(true)
    useEffect(() => {
        getRaceDetail(uuid, activeLanguage?.key)
    }, [uuid, activeLanguage?.key])


    console.log('race = ', data?.race?.content)
    const getRaceDetail = (uuid, language) => {
        if (language && uuid)
            associateServices.getRaceDetail({uuid, language}).then(res => {
                setData(res?.data)
                setLoading(false)
            })
    }


    return (
        <div className="section section--first">
            <div className="container">
                {
                    loading ? <Loading/> :
                        <div className="row">
                            <div className="col-12">
                                <h1 className="section__title section__title--article">
                                    {/*{t(`promotions.${data?.race?.key}`)}*/}
                                    {data?.race?.title}
                                </h1>
                            </div>

                            <div className="col-12 col-xxl-10 offset-xxl-1">
                                <div className="content">
                                    <div className="content__main content__main--big">


                                        <Countback nextDate={data?.race?.end} showDesc={false}/>


                                        <div className="article">
                                            {
                                                data?.race?.content ?
                                                    <div dangerouslySetInnerHTML={{__html: data?.race?.content}}/> :
                                                    <p>{data?.race?.description}</p>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="col-12">
                                <Link
                                    to={stringHelper.getLocalizedPath(currentLanguage, '/casino')}
                                    className="section__more" type="button">
                                    {t('lowbar.casino')}
                                </Link>
                            </div>
                        </div>
                }
            </div>
        </div>
    )
}

export default RaceDetail
